import { connect } from 'react-redux'
import { makeStyles } from "@material-ui/styles";
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Typography, Button, TablePagination, Box, Paper, CardContent, Modal, IconButton, TextField, FormControl, Select, InputLabel, MenuItem, CircularProgress, Autocomplete, Input, Chip, Snackbar, Alert } from "@mui/material";
import * as Action from "../../actions/adminAction"
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { json, useNavigate } from "react-router-dom";
import PersonAddRounded from "@mui/icons-material/PersonAddRounded";
import { Edit, Visibility, Delete } from "@mui/icons-material";
import React, { useState } from 'react';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

const shiftArray = [
    { label: 'morning', value: 'morning' },
    { label: 'evening', value: 'evening' },
]

const monthOptions = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
];

export const AssignTrainer = ({
    getAllTrainers,
    getAllTrainingModuleData,
    getDistrictWiseTalukaData,
    getAllDistrictData,
    getTalukaWisePanchayat,
    AssignTrainertoPanchayat,
    userDetails,
    setActiveList,
    getSingleTrainerData,
    DistrictWisePanchayat,
    BulkTrainingInsert,
    getTrainingByTrainer,
    updateTrainingAssignTrainerBulk,
    deleteTrainingByTrainer,
}) => {
    const classes = useStyles()
    const navigate = useNavigate()
    const [imgloader, setImgLoader] = useState(false)

    // Array Variable
    const [cityArray, setCityArray] = useState([]);
    const [talukaArray, setTalukaArray] = useState([]);
    const [gramPanchayatArray, setGramPanchayatArray] = useState([])
    const [moduleArray, setModuleArray] = useState([])

    // data variables
    const [city, setCity] = useState('')
    const [taluka, setTaluka] = useState([])
    const [panchayat, setPanchayat] = useState([])
    const [moduleType, setModuleType] = useState([])
    const [month, setMonth] = useState('')
    const [trainerData, setTrainerData] = useState([])
    const [loader, setLoader] = useState(false)
    const [SelectedTrainer, setSelectedTrainer] = useState('')
    const [searchTrainer, setsearchTrainer] = useState('')

    // Bulk Upload
    const [openBulk, setOpenBulk] = useState(false)
    const [bulkDistrict, setBulkDistrict] = useState('')
    const [bulkModule, setBulkModule] = useState('')
    const [bulkData, setBulkData] = useState([])
    const [array, setArray] = useState([])
    const [noGram, setNoGram] = useState(false)

    // Error Variables
    const [cityError, setcityError] = useState(false)
    const [TalukaError, setTalukaError] = useState(false)
    const [PanchayatError, setPanchayatError] = useState(false)
    const [moduleError, setModuleError] = useState(false)
    const [AlreadyAssign, setAlreadyAssign] = useState(false)

    const [SelectcityError, setSelectcityError] = useState(false);
    const [SelectTalukaError, setSelectTalukaError] = useState(false);
    const [SelectPanchyatError, setSelectPanchyatError] = useState(false);
    const [SelectMonthError, setSelectMonthError] = useState(false);
    const [SelectModuleError, setSelectModuleError] = useState(false)
    const [searchTrainerError, setsearchTrainerError] = useState(false);

    // Bulk Error variables
    const [bulkDistrictError, setBulkDistrictError] = useState(false)
    const [bulkModuleError, setBulkModuleError] = useState(false)
    const [error, setErr] = useState([])
    const [showErr, setShowErr] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)

    // Table Pagination variables
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    // Modal Variables
    const [assign, setAssign] = useState(false)
    const [assignmentFull, setAssignmentFull] = useState(false)

    // ─── Edit / Delete state ───────────────────────────────────────────
    const [isEditMode, setIsEditMode] = useState(false)
    const [editLoader, setEditLoader] = useState(false)
    const [editAssignments, setEditAssignments] = useState([])
    const [editMonthAssignments, setEditMonthAssignments] = useState([])
    const [editAssignment, setEditAssignment] = useState(null)
    const [editMonths, setEditMonths] = useState([])
    const [monthLoading, setMonthLoading] = useState(false)

    // ─── COMBINED edit selections (create jaisa) ───────────────────────
    const [editTalukaArray, setEditTalukaArray] = useState([])
    const [editSchoolArray, setEditSchoolArray] = useState([])
    const [editSelectedTalukas, setEditSelectedTalukas] = useState([])
    const [editSelectedSchools, setEditSelectedSchools] = useState([])
    const [editSelectedModules, setEditSelectedModules] = useState([])
    const [updateLoader, setUpdateLoader] = useState(false)

    // Delete confirm state
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [deleteTarget, setDeleteTarget] = useState(null)
    const [deleteLoader, setDeleteLoader] = useState(false)

    // ✅ TOAST — state + helpers
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' })

    const showToast = (message, severity = 'success') => {
        setToast({ open: true, message, severity })
    }

    const handleToastClose = (event, reason) => {
        if (reason === 'clickaway') return
        setToast(prev => ({ ...prev, open: false }))
    }

    // useEffects
    React.useEffect(() => {
        getDistrict()
        getModule()
        getTrainerData();
    }, [])

    React.useEffect(() => {
        if (city && !isEditMode) {
            setTaluka([])
            setPanchayat([])
            getTaluka()
        } else if (city && isEditMode) {
            // edit mode me district locked hai, taluka array already set hota hai
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [city])

    React.useEffect(() => {
        if (taluka.length && !isEditMode) {
            setPanchayat([])
            getPanchayat()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taluka])

    // Edit mode: taluka change hone par school options reload karo
    React.useEffect(() => {
        if (!isEditMode) return
        const loadEditSchools = async () => {
            if (!editSelectedTalukas.length || !city?._id) {
                setEditSchoolArray([])
                setEditSelectedSchools([])
                return
            }
            const res = await getTalukaWisePanchayat({
                taluka_id: editSelectedTalukas.map(t => t._id),
                distric_id: city._id,
            })
            const opts = (res !== 'No data found' && Array.isArray(res)) ? res : []
            setEditSchoolArray(opts)
            // jo selected schools ab options me nahi hain unhe hatao
            setEditSelectedSchools(prev =>
                prev.filter(s => opts.some(o => (o.schoolId || o._id) === (s.schoolId || s._id)))
            )
        }
        loadEditSchools()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editSelectedTalukas])

    React.useEffect(() => {
        if (searchTrainer === null) {
            getTrainerData()
        }
    }, [searchTrainer])

    // Fetching Data
    const getModule = async () => {
        const result = await getAllTrainingModuleData()
        if (result !== 'No data found') {
            setModuleArray(result)
        }
    }

    const getDistrict = async () => {
        const result = await getAllDistrictData()
        if (result !== 'No data found') {
            setCityArray(result)
        }
    }

    const getTaluka = async () => {
        setTalukaError(false)
        const result = await getDistrictWiseTalukaData({ distric_id: city?._id })
        if (result !== 'No data found') {
            setTalukaArray(result)
        } else {
            setTalukaError(true)
        }
    }

    const getPanchayat = async () => {
        setPanchayatError(false)

        const result = await getTalukaWisePanchayat({
            taluka_id: taluka.map(t => t._id),
            distric_id: city?._id
        })

        if (result !== 'No data found') {
            setGramPanchayatArray(result)
        } else {
            setPanchayatError(true)
        }
    }

    // Table Pagination
    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // ─── Validation ────────────────────────────────────────────────────
    const validate = () => {
        let IsformValid = true;

        if (!city) { IsformValid = false; setSelectcityError(true) }

        if (isEditMode) {
            if (!month) { IsformValid = false; setSelectMonthError(true) }
            if (!editSelectedTalukas.length) { IsformValid = false; setSelectTalukaError(true) }
            if (!editSelectedSchools.length) { IsformValid = false; setSelectPanchyatError(true) }
            if (!editSelectedModules.length) { IsformValid = false; setSelectModuleError(true) }
        } else {
            if (!taluka.length) { IsformValid = false; setSelectTalukaError(true) }
            if (!panchayat || panchayat.length === 0) { IsformValid = false; setSelectPanchyatError(true) }
            if (!moduleType || moduleType.length === 0) { IsformValid = false; setSelectModuleError(true) }
            if (!month) { IsformValid = false; setSelectMonthError(true) }
        }

        return IsformValid;
    }

    const getTrainerData = async () => {
        setLoader(true)
        const result = await getAllTrainers()
        if (result) {
            setTrainerData(result)
            setLoader(false)
        } else {
            setLoader(false)
        }
    }

    // ─── close modal (shared) ─────────────────────────────────────────
    const closeAssignModal = () => {
        setAssign(false)
        setIsEditMode(false)
        setEditAssignment(null)
        setEditMonthAssignments([])
        setEditMonths([])
        setEditSelectedTalukas([])
        setEditSelectedSchools([])
        setEditSelectedModules([])
        setEditTalukaArray([])
        setEditSchoolArray([])
        setMonth('')
        setCity('')
        setTaluka([])
        setPanchayat([])
        setModuleType([])
    }

    // ─── Reset & open Assign modal (CREATE) ───────────────────────────
    const AssignTrainer = () => {
        setCity('')
        setTaluka([])
        setPanchayat([])
        setModuleType([])
        setMonth('')
        setSelectcityError(false)
        setSelectPanchyatError(false)
        setSelectTalukaError(false)
        setSelectMonthError(false)
        setSelectModuleError(false)

        setIsEditMode(false)
        setEditAssignments([])
        setEditMonthAssignments([])
        setEditAssignment(null)
        setEditMonths([])
        setEditSelectedTalukas([])
        setEditSelectedSchools([])
        setEditSelectedModules([])
        setEditTalukaArray([])
        setEditSchoolArray([])

        setAssign(true)
    }

    // ─── Open Edit modal ───────────────────────────────────────────────
    const openEditModal = async (trainerRow) => {
        setEditLoader(true)
        setIsEditMode(true)
        setSelectedTrainer(trainerRow)

        // reset everything
        setEditAssignment(null)
        setEditAssignments([])
        setEditMonthAssignments([])
        setEditMonths([])
        setEditSelectedTalukas([])
        setEditSelectedSchools([])
        setEditSelectedModules([])
        setEditTalukaArray([])
        setEditSchoolArray([])

        setCity('')
        setTaluka([])
        setPanchayat([])
        setModuleType([])
        setMonth('')
        setSelectcityError(false)
        setSelectPanchyatError(false)
        setSelectTalukaError(false)
        setSelectMonthError(false)
        setSelectModuleError(false)

        const result = await getTrainingByTrainer({ trainer_id: trainerRow?._id })
        const assignments = result?.data || []

        setEditAssignments(assignments)
        const months = [...new Set(assignments.map(a => a?.month).filter(Boolean))]
        setEditMonths(months)

        setEditLoader(false)
        setAssign(true)
    }

    // ─── EDIT: month pick hone par combined prefill ───────────────────
    const handleEditMonthChange = async (selectedMonth) => {
        setMonth(selectedMonth)
        setSelectMonthError(false)

        // reset selections
        setCity('')
        setTaluka([])
        setPanchayat([])
        setModuleType([])
        setEditAssignment(null)
        setEditMonthAssignments([])
        setEditSelectedTalukas([])
        setEditSelectedSchools([])
        setEditSelectedModules([])
        setEditTalukaArray([])
        setEditSchoolArray([])

        if (!selectedMonth) return
        setMonthLoading(true)

        const result = await getTrainingByTrainer({
            trainer_id: SelectedTrainer?._id,
            month: selectedMonth,
        })
        const assignments = result?.data || []
        setMonthLoading(false)

        if (!assignments.length) return

        setEditMonthAssignments(assignments)
        const base = assignments[0]
        setEditAssignment(base)

        // District
        const district = cityArray.find(d => d?._id === base?.distric_id)
        if (!district) return
        setCity(district)

        // Taluka options
        const talukaResult = await getDistrictWiseTalukaData({ distric_id: base?.distric_id })
        if (!(talukaResult !== 'No data found' && Array.isArray(talukaResult))) return
        setEditTalukaArray(talukaResult)

        // Existing talukas (unique)
        const talukaIds = new Set()
        assignments.forEach(a => {
            if (Array.isArray(a?.taluka_id)) a.taluka_id.forEach(id => talukaIds.add(id))
            else if (a?.taluka_id) talukaIds.add(a.taluka_id)
            if (Array.isArray(a?.grampanchayatData)) {
                a.grampanchayatData.forEach(g => g?.taluka_id && talukaIds.add(g.taluka_id))
            }
        })
        const prefilledTalukas = talukaResult.filter(t => talukaIds.has(t?._id))
        setEditSelectedTalukas(prefilledTalukas)

        // Schools — selected talukas ke hisaab se
        let allSchools = []
        if (prefilledTalukas.length) {
            const res = await getTalukaWisePanchayat({
                taluka_id: prefilledTalukas.map(t => t._id),
                distric_id: base?.distric_id,
            })
            allSchools = (res !== 'No data found' && Array.isArray(res)) ? res : []
        }
        setEditSchoolArray(allSchools)

        // Existing schools
        const schoolIds = new Set()
        assignments.forEach(a => {
            const sId = Array.isArray(a?.grampanchayat_id) ? a.grampanchayat_id[0] : a?.grampanchayat_id
            if (sId) schoolIds.add(sId)
        })
        const prefilledSchools = allSchools.filter(
            p => schoolIds.has(p?._id) || schoolIds.has(p?.schoolId)
        )
        setEditSelectedSchools(prefilledSchools)

        // Existing modules
        const moduleIds = new Set()
        assignments.forEach(a => {
            if (Array.isArray(a?.trainingModule_id)) a.trainingModule_id.forEach(id => moduleIds.add(id))
            else if (a?.trainingModule_id) moduleIds.add(a.trainingModule_id)
        })
        setEditSelectedModules(moduleArray.filter(m => moduleIds.has(m?._id)))
    }

    // ─── Submit (create OR update) ────────────────────────────────────
    const AssignTrainerData = async () => {
        if (!validate()) return;

        const name = SelectedTrainer?.firstName + " " + SelectedTrainer?.lastName

        // ══════════ UPDATE (COMBINED) ══════════
        if (isEditMode && editMonthAssignments.length > 0) {
            setUpdateLoader(true)
            try {
                // 1) Purane month-wise assignments delete karo
                for (const a of editMonthAssignments) {
                    await deleteTrainingByTrainer({
                        trainingAssignTrainer_id: a?._id,
                        updatedBy: userDetails?._id,
                    })
                }

                // 2) Naya combined bulk assign karo (create jaisa)
                const result = await AssignTrainertoPanchayat({
                    trainer_id: SelectedTrainer?._id,
                    trainerName: name,
                    trainerMobile: SelectedTrainer?.contactNo,
                    trainingModule_id: editSelectedModules.map(m => m._id),
                    trainingModuleName: editSelectedModules.map(m => m.trainingModuleName),
                    categoryType: editSelectedModules.map(m => m.categoryType),
                    distric_id: city?._id,
                    districtName: city?.districtName,
                    grampanchayat_id: editSelectedSchools.map(p => p.schoolId),
                    grampanchayatName: editSelectedSchools.map(p => p.schoolName),
                    month: month,
                    createdBy: userDetails?._id,
                    grampanchayatData: editSelectedSchools.map(p => ({
                        taluka_id: p.taluka_id,
                        talukaName: p.talukaName,
                        grampanchayat_id: p.schoolId,
                        grampanchayatName: p.schoolName,
                    })),
                })

                if (result) {
                    if (result.message === 'Trainer already assign to this shift and date') {
                        setModuleError(true)
                    } else if (result.message === 'Trainer assignment full') {
                        setAssignmentFull(true)
                    } else if (result.message === 'Trainer already assigned') {
                        setAlreadyAssign(true)
                    } else {
                        closeAssignModal()
                        getTrainerData()
                        // ✅ TOAST — update success
                        const msg = result?.skippedCount > 0
                            ? `Updated successfully. ${result.insertedCount} created, ${result.skippedCount} skipped.`
                            : `Updated successfully. ${result.insertedCount ?? 0} assignment(s) created.`
                        showToast(msg, result?.skippedCount > 0 ? 'warning' : 'success')
                    }
                } else {
                    closeAssignModal()
                    getTrainerData()
                    // ✅ TOAST — update complete (no explicit message)
                    showToast('Update completed.', 'info')
                }
            } catch (err) {
                console.error('Update failed:', err)
                // ✅ TOAST — update failed
                showToast('Update failed. Please try again.', 'error')
            } finally {
                setUpdateLoader(false)
            }
            return
        }

        // ══════════ CREATE ══════════
        const result = await AssignTrainertoPanchayat({
            trainer_id: SelectedTrainer?._id,
            trainerName: name,
            trainerMobile: SelectedTrainer?.contactNo,
            trainingModule_id: moduleType.map(m => m._id),
            trainingModuleName: moduleType.map(m => m.trainingModuleName),
            categoryType: moduleType.map(m => m.categoryType),
            distric_id: city?._id,
            districtName: city?.districtName,
            grampanchayat_id: panchayat.map(p => p.schoolId),
            grampanchayatName: panchayat.map(p => p.schoolName),
            month: month,
            createdBy: userDetails?._id,
            grampanchayatData: panchayat.map(p => ({
                taluka_id: p.taluka_id,
                talukaName: p.talukaName,
                grampanchayat_id: p.schoolId,
                grampanchayatName: p.schoolName,
            })),
        })

        if (result) {
            if (result.message === 'Trainer already assign to this shift and date') {
                setModuleError(true)
            } else if (result.message === 'Trainer assignment full') {
                setAssignmentFull(true)
            } else if (result.message === 'Trainer already assigned') {
                setAlreadyAssign(true)
            } else {
                setAssign(false)
                // ✅ TOAST — assign success
                const msg = result?.skippedCount > 0
                    ? `Assigned successfully. ${result.insertedCount} created, ${result.skippedCount} skipped.`
                    : `Assigned successfully. ${result.insertedCount ?? 0} assignment(s) created.`
                showToast(msg, result?.skippedCount > 0 ? 'warning' : 'success')
            }
        } else {
            setAssign(false)
            // ✅ TOAST — assignment complete (no explicit message)
            showToast('Assignment completed.', 'info')
        }
    }

    // ─── Delete flow ───────────────────────────────────────────────────
    const openDeleteConfirm = (trainerRow) => {
        setDeleteTarget(trainerRow)
        setDeleteConfirmOpen(true)
    }

    const handleDelete = async () => {
        if (!deleteTarget) return
        setDeleteLoader(true)
        try {
            const res = await getTrainingByTrainer({ trainer_id: deleteTarget?._id })
            const assignments = res?.data || []

            if (!assignments.length) {
                setDeleteConfirmOpen(false)
                setDeleteTarget(null)
                setDeleteLoader(false)
                // ✅ TOAST — no data
                showToast('No assignments found to delete.', 'info')
                return
            }

            for (const a of assignments) {
                await deleteTrainingByTrainer({
                    trainingAssignTrainer_id: a?._id,
                    updatedBy: userDetails?._id,
                })
            }

            setDeleteConfirmOpen(false)
            setDeleteTarget(null)
            getTrainerData()
            // ✅ TOAST — delete success
            showToast(`Deleted ${assignments.length} assignment(s) successfully.`, 'success')
        } catch (err) {
            console.error('Delete failed:', err)
            // ✅ TOAST — delete failed
            showToast('Delete failed. Please try again.', 'error')
        } finally {
            setDeleteLoader(false)
        }
    }

    const getSingleTrainer = async () => {
        setsearchTrainerError(false)
        setLoader(true)
        if (searchTrainer) {
            const result = await getSingleTrainerData({ user_id: searchTrainer?._id })
            if (result) {
                setTrainerData(result)
                setLoader(false)
            }
        } else {
            setsearchTrainerError(true)
            setLoader(false)
            getTrainerData()
        }
    }

    const bulkValidate = () => {
        let IsformValid = true;
        if (!bulkDistrict) { IsformValid = false; setBulkDistrictError(true) }
        if (!bulkModule) { IsformValid = false; setBulkModuleError(true) }
        return IsformValid;
    }

    const getExcel = async () => {
        setBulkDistrictError(false)
        setBulkModuleError(false)
        if (bulkValidate()) {
            await getDistrictData()
        }
    }

    const getDistrictData = async () => {
        let arr = []
        arr.push(bulkDistrict?._id)
        const result = await DistrictWisePanchayat({ "distric_id": arr })
        setBulkData(result)
        if (result !== 'No data found') {
            genrateExcel(result)
        } else {
            setNoGram(true)
        }
    }

    const genrateExcel = async (result) => {
        const customHeadings =
            result.length > 0 &&
            result.map((item, index) => ({
                "District": item?.districtName,
                "Taluka": item?.talukaName,
                "GramPanchayat": item?.schoolName,
                "Module": bulkModule?.trainingModuleName,
                "Assignment_Date": "",
                "Timing": "",
                "Trainer_1_Name": "",
                "Triner_1_Mobile": "",
                "Trainer_2_Name": "",
                "Triner_2_Mobile": "",
            }));
        downloadExcel(customHeadings);
    }

    const downloadExcel = (customHeadings) => {
        let dataSet = [];
        dataSet = customHeadings;
        const worksheet = XLSX.utils.json_to_sheet(dataSet);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "TrainingBulkUpload.xlsx");
    };

    const handleChangeExcel = (e) => {
        setImgLoader(true)
        var name = e.target.files[0].name
        const ext = name.split(".")[1];
        if (ext === "xlsx") {
            const reader = new FileReader();
            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data1 = XLSX.utils.sheet_to_json(wb.Sheets[wsname], { raw: false });
                setArray(data1)
                validation(data1)
            };
            reader.readAsBinaryString(e.target.files[0]);
        }
        else {
            setLoader(false)
        }
        document.getElementById("myInput").value = ""
    }

    const validation = async (data) => {
        if (data.length > 0) {
            let errorArray = []
            data.map((row, index) => {
                if (!row?.District) {
                    errorArray.push(`Row ${index + 2} Enter District Name`)
                } else if (row?.District.match(/[0-9+@#$&%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid District Name`)
                }
                if (!row?.Taluka) {
                    errorArray.push(`Row ${index + 2} Enter Taluka Name`)
                } else if (row?.Taluka.match(/[0-9+@#$&%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid Taluka Name`)
                }
                if (!row?.GramPanchayat) {
                    errorArray.push(`Row ${index + 2} Enter School Name`)
                } else if (row?.GramPanchayat.match(/[0-9+@#$&%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid School Name`)
                }
                if (!row?.Module) {
                    errorArray.push(`Row ${index + 2} Enter Module Name`)
                } else if (row?.Module.match(/[+@#$%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid Module Name`)
                }
                if (!row?.Assignment_Date) {
                    errorArray.push(`Row ${index + 2} Enter Assignment Date`)
                } else if (!row?.Assignment_Date.split('-').length !== 0 && row?.Assignment_Date.includes("/") === false) {
                    let date = row?.Assignment_Date.split('-').map(Number)
                    if (isNaN(date[0])) {
                        errorArray.push(`Row ${index + 2} Assignment Date year is not valid`)
                    } else if (date[0] < 2000 || date[0] > 9999) {
                        errorArray.push(`Row ${index + 2} Assignment Date year is not valid`)
                    }
                    if (!isNaN(date[1]) && date[1] < 0 || date[1] > 12) {
                        errorArray.push(`Row ${index + 2} Assignment Date month is not valid`)
                    }
                    if (!isNaN(date[2]) && date[2] < 0 || date[2] > 31) {
                        errorArray.push(`Row ${index + 2} Assignment Date day is not valid`)
                    }
                } else {
                    errorArray.push(`Row ${index + 2} Enter Assignment Date in YYYY-MM-DD format`)
                }

                if (!row?.Shift) {
                    errorArray.push(`Row ${index + 2} Enter Shift Name`)
                } else if (row?.Shift.toUpperCase().localeCompare("MORNING") !== 0 && row?.Shift.toUpperCase().localeCompare("EVENING") !== 0) {
                    errorArray.push(`Row ${index + 2}  Shift Name Should be MORNING or EVENING `)
                }

                if (!row?.Trainer_1_Name) {
                    errorArray.push(`Row ${index + 2} Enter Trainer_1_Name`)
                } else if (row?.Trainer_1_Name.match(/[0-9+@#$&%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid Trainer_1_Name`)
                }
                if (!row?.Trainer_2_Name) {
                    errorArray.push(`Row ${index + 2} Enter Trainer_2_Name`)
                } else if (row?.Trainer_2_Name.match(/[0-9+@#$&%!~]/)) {
                    errorArray.push(`Row ${index + 2} Invalid Trainer_2_Name`)
                }
                if (!row?.Triner_1_Mobile) {
                    errorArray.push(`Row ${index + 2} Enter Triner_1_Mobile `)
                } else if (row?.Triner_1_Mobile.match(/[A-Za-z+@#$&%!~]/) ||
                    (row?.Triner_1_Mobile.length !== 10 && row?.Triner_1_Mobile.length !== 0)) {
                    errorArray.push(`Row ${index + 2} Invalid Triner_1_Mobile `)
                }
                if (!row?.Triner_2_Mobile) {
                    errorArray.push(`Row ${index + 2} Enter Triner_2_Mobile `)
                } else if (row?.Triner_2_Mobile.match(/[A-Za-z+@#$&%!~]/) ||
                    (row?.Triner_2_Mobile.length !== 10 && row?.Triner_2_Mobile.length !== 0)) {
                    errorArray.push(`Row ${index + 2} Invalid Triner_2_Mobile `)
                }
            })
            setErr(errorArray)
            if (errorArray.length > 0) {
                DownloadTextFile(errorArray);
                setShowErr(true)
            } else {
                const result = await BulkTrainingInsert(data)
                if (result !== undefined) {
                    if (result?.msg === "successful") {
                        setShowSuccess(true)
                        // ✅ TOAST — bulk upload success
                        showToast('Bulk upload completed successfully.', 'success')
                    } else {
                        DownloadTextFile(result);
                        setShowErr(true)
                    }
                } else {
                    setImgLoader(false)
                }
            }
        }
        setImgLoader(false)
    }

    const DownloadTextFile = (err) => {
        var content = "";
        content += "Following Error Occured in Recent Excel document\n";
        for (var i = 0; i < err.length; i++) {
            content += err[i]
            content += "\n";
        }
        const element = document.createElement("a");
        const file = new Blob([content], { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        element.download = "ExecelError.txt";
        document.body.appendChild(element);
        element.click();
    }

    // ─── helper: edit mode me kaunsa array use karna hai ──────────────
    const talukaOptions = isEditMode ? editTalukaArray : talukaArray
    const talukaValue = isEditMode ? editSelectedTalukas : taluka
    const schoolOptions = isEditMode ? editSchoolArray : gramPanchayatArray
    const schoolValue = isEditMode ? editSelectedSchools : panchayat
    const moduleValue = isEditMode ? editSelectedModules : moduleType

    return (
        <div className={classes.main}>
            <center>
                <Typography style={{ margin: 20, fontSize: 30, fontWeight: 600 }} >Assign School To Trainer</Typography>
            </center>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginTop: 10 }}>
                <Button variant='contained' onClick={() => setOpenBulk(true)} >Bulk Upload DistrictWise</Button>
            </div>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                <a style={{ color: '#555657' }} target="_blank" href='https://gsda-images2.s3.ap-south-1.amazonaws.com/reports/66754a850417632745afe5e9_reports.pdf'>*Instructions for Excel upload</a>
            </div>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: 50 }}>
                <div>
                    <Autocomplete
                        id='Trainer-data'
                        sx={{ width: 300 }}
                        options={trainerData}
                        autoHighlight
                        disablePortal
                        freeSolo
                        disabled={trainerData === undefined || trainerData.length === 0}
                        getOptionLabel={(option) => option?.firstName + " " + option?.lastName + " - " + option?.contactNo}
                        renderInput={(params) => (<TextField {...params} label="Select Trainer" />)}
                        onChange={(event, newValue) => {
                            setsearchTrainer(newValue);
                        }}
                    />
                    {searchTrainerError ? <span style={{ color: 'red' }} >*Please Select trainer first</span> : null}
                </div>
                <Button variant='contained' style={{ marginLeft: 5, height: 55 }} onClick={() => getSingleTrainer()} >Get Trainer</Button>
            </div>
            {
                loader ? <CircularProgress color="primary" /> : <Paper sx={{ overflow: 'hidden', width: '90%' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>SR No.</strong></TableCell>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Name</strong></TableCell>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Mobile</strong></TableCell>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Email-Id</strong></TableCell>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Address</strong></TableCell>
                                    <TableCell style={{ fontSize: 16, textAlign: 'center' }}><strong>Action</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    trainerData !== 'No data found' && trainerData !== undefined && trainerData.length > 0 ? trainerData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{page * rowsPerPage + (index + 1)}</TableCell>
                                                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{row?.firstName} {row?.lastName}</TableCell>
                                                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{row?.contactNo}</TableCell>
                                                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{row?.emailId ? row?.emailId : '-'}</TableCell>
                                                <TableCell style={{ fontSize: 16, textAlign: 'center' }}>{row?.currentAddressLine1}</TableCell>
                                                <TableCell style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    <Stack
                                                        direction="row"
                                                        spacing={1}
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        sx={{ width: '90%' }}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                textTransform: 'none',
                                                                borderRadius: 2,
                                                                px: 2,
                                                                height: 36,
                                                                boxShadow: 'none',
                                                                '&:hover': { boxShadow: 'none' },
                                                            }}
                                                            onClick={() => { AssignTrainer(); setSelectedTrainer(row) }}
                                                        >
                                                            Assign School
                                                        </Button>

                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            color="warning"
                                                            startIcon={!editLoader ? <Edit fontSize="small" /> : null}
                                                            disabled={editLoader}
                                                            sx={{
                                                                textTransform: 'none',
                                                                borderRadius: 2,
                                                                px: 2,
                                                                height: 36,
                                                                minWidth: 92,
                                                            }}
                                                            onClick={() => openEditModal(row)}
                                                        >
                                                            {editLoader ? <CircularProgress size={16} color="inherit" /> : 'Edit'}
                                                        </Button>

                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            color="error"
                                                            startIcon={<Delete fontSize="small" />}
                                                            sx={{
                                                                textTransform: 'none',
                                                                borderRadius: 2,
                                                                px: 2,
                                                                height: 36,
                                                            }}
                                                            onClick={() => openDeleteConfirm(row)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                        : <TableRow>NO Data Found</TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={trainerData !== "No data found" && trainerData?.length > 0 ? trainerData?.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            }

            {/* ── Assign / Edit School modal (COMBINED) ─────────────────── */}
            <Modal
                className={classes.middlePosition}
                sx={{ marginTop: 18 }}
                open={assign}
                onClose={(e) => {
                    e.preventDefault();
                    closeAssignModal()
                }}
            >
                <Paper className={classes.profilemodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>
                                {isEditMode ? 'Edit Assigned School' : 'Assign School'}
                            </Typography>
                            {isEditMode && SelectedTrainer && (
                                <Typography variant='caption' color="textSecondary">
                                    Trainer: {SelectedTrainer?.firstName} {SelectedTrainer?.lastName} ({SelectedTrainer?.contactNo})
                                </Typography>
                            )}
                        </Stack>
                        <IconButton aria-label="close" onClick={e => { e.preventDefault(); closeAssignModal() }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>

                    {/* Month — edit mode me months selector, create me monthOptions */}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20, marginBottom: 10 }}>
                        <FormControl sx={{ m: 1, marginRight: 3 }}>
                            <InputLabel id="month-label">Month</InputLabel>
                            <Select
                                style={{ width: 250, height: 56 }}
                                id="month-label"
                                label="Month"
                                value={month}
                                onChange={(e) => {
                                    if (isEditMode) {
                                        handleEditMonthChange(e.target.value)
                                    } else {
                                        setMonth(e.target.value);
                                        setSelectMonthError(false);
                                    }
                                }}
                                MenuProps={{ style: { maxHeight: 400 } }}
                            >
                                {isEditMode
                                    ? editMonths.map((m) => (
                                        <MenuItem key={m} value={m}>{m}</MenuItem>
                                    ))
                                    : monthOptions.map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            {monthLoading && <Typography variant="caption" color="textSecondary">Loading...</Typography>}
                            {SelectMonthError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Month</span> : null}
                        </FormControl>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
                        {/* District */}
                        <FormControl sx={{ m: 1, marginRight: 3 }}>
                            <InputLabel id="district-label">District</InputLabel>
                            <Select
                                style={{ width: 250, height: 56 }}
                                id="district-label"
                                label="District"
                                value={city}
                                onChange={(e) => {
                                    setCity(e.target.value);
                                    setTaluka([]);
                                    setPanchayat([]);
                                }}
                                disabled={cityArray === undefined || cityArray?.length === 0 || isEditMode}
                                MenuProps={{ style: { maxHeight: 400 } }}
                            >
                                {cityArray !== undefined && cityArray?.map((item) => (
                                    <MenuItem key={item?._id} value={item}>
                                        {item?.districtName}
                                    </MenuItem>
                                ))}
                            </Select>
                            {cityError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select City</span> : null}
                            {SelectcityError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select City</span> : null}
                        </FormControl>

                        {/* Taluka — multiple, combined */}
                        <FormControl sx={{ m: 1, marginRight: 3 }}>
                            <InputLabel id="taluka-label">Taluka</InputLabel>
                            <Select
                                multiple
                                style={{ width: 250, height: 56 }}
                                id="taluka-label"
                                label="Taluka"
                                value={talukaValue}
                                onChange={(e) => {
                                    if (isEditMode) {
                                        setEditSelectedTalukas(e.target.value);
                                        setSelectTalukaError(false);
                                    } else {
                                        setTaluka(e.target.value);
                                        setSelectTalukaError(false);
                                    }
                                }}
                                disabled={talukaOptions.length === 0 || talukaOptions === undefined}
                                MenuProps={{ style: { maxHeight: 400 } }}
                                renderValue={(selected) => (
                                    selected.map((s) => (
                                        <Chip
                                            key={s._id}
                                            label={s.talukaName}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#e3f2fd',
                                                color: '#052850',
                                                fontWeight: 500,
                                                maxWidth: '100%',
                                                height: 22,
                                                fontSize: 11,
                                            }}
                                        />
                                    ))
                                )}
                            >
                                {talukaOptions && talukaOptions?.map((item) => (
                                    <MenuItem key={item?._id} value={item}>
                                        {item?.talukaName}
                                    </MenuItem>
                                ))}
                            </Select>
                            {TalukaError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Taluka</span> : null}
                            {SelectTalukaError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Taluka</span> : null}
                        </FormControl>

                        {/* School — multiple, combined */}
                        <FormControl sx={{ m: 1, marginRight: 3 }}>
                            <InputLabel id="school-label">School</InputLabel>
                            <Select
                                multiple
                                id="school-label"
                                label="School"
                                value={schoolValue}
                                onChange={(e) => {
                                    if (isEditMode) {
                                        setEditSelectedSchools(e.target.value);
                                        setSelectPanchyatError(false);
                                    } else {
                                        setPanchayat(e.target.value);
                                        setSelectPanchyatError(false);
                                    }
                                }}
                                disabled={schoolOptions.length === 0 || schoolOptions === undefined}
                                MenuProps={{ style: { maxHeight: 400 } }}
                                sx={{
                                    width: 250,
                                    height: 56,
                                    '& .MuiOutlinedInput-root': { height: 56, overflow: 'hidden' },
                                    '& .MuiSelect-select': {
                                        display: 'flex !important',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        alignContent: 'flex-start',
                                        gap: '4px',
                                        height: '100% !important',
                                        maxHeight: '100%',
                                        overflowY: 'auto !important',
                                        overflowX: 'hidden',
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingRight: '24px !important',
                                        boxSizing: 'border-box',
                                    },
                                }}
                                renderValue={(selected) => (
                                    selected.map((s) => (
                                        <Chip
                                            key={s._id}
                                            label={s.schoolName}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#e3f2fd',
                                                color: '#1565c0',
                                                fontWeight: 500,
                                                maxWidth: '100%',
                                                height: 22,
                                                fontSize: 11,
                                            }}
                                        />
                                    ))
                                )}
                            >
                                {schoolOptions && schoolOptions?.map((item) => (
                                    <MenuItem key={item?._id} value={item}>
                                        {item?.schoolName}
                                    </MenuItem>
                                ))}
                            </Select>
                            {PanchayatError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select School</span> : null}
                            {SelectPanchyatError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select School</span> : null}
                        </FormControl>

                        {/* Module — multiple, combined */}
                        <FormControl sx={{ m: 1, marginRight: 3 }}>
                            <InputLabel id="module-label">Module</InputLabel>
                            <Select
                                multiple
                                id="module-label"
                                label="Module"
                                value={moduleValue}
                                disabled={moduleArray === undefined || moduleArray.length === 0}
                                onChange={(e) => {
                                    const selectedModules = e.target.value;
                                    if (selectedModules.includes('__all_modules__')) {
                                        const allSelected = moduleValue.length === moduleArray.length;
                                        if (isEditMode) {
                                            setEditSelectedModules(allSelected ? [] : moduleArray);
                                        } else {
                                            setModuleType(allSelected ? [] : moduleArray);
                                        }
                                    } else {
                                        if (isEditMode) {
                                            setEditSelectedModules(selectedModules);
                                        } else {
                                            setModuleType(selectedModules);
                                        }
                                    }
                                    setSelectModuleError(false);
                                }}
                                MenuProps={{ style: { maxHeight: 400 } }}
                                sx={{
                                    width: 260,
                                    height: 56,
                                    '& .MuiOutlinedInput-root': { height: 56, overflow: 'hidden' },
                                    '& .MuiSelect-select': {
                                        display: 'flex !important',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        alignContent: 'flex-start',
                                        gap: '4px',
                                        height: '100% !important',
                                        maxHeight: '100%',
                                        overflowY: 'auto !important',
                                        overflowX: 'hidden',
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        paddingRight: '24px !important',
                                        boxSizing: 'border-box',
                                    },
                                }}
                                renderValue={(selected) => (
                                    selected.map((m) => (
                                        <Chip
                                            key={m._id}
                                            label={m.trainingModuleName}
                                            size="small"
                                            sx={{
                                                backgroundColor: '#ede7f6',
                                                color: '#5e35b1',
                                                fontWeight: 500,
                                                maxWidth: '100%',
                                                height: 22,
                                                fontSize: 11,
                                            }}
                                        />
                                    ))
                                )}
                            >
                                <MenuItem value="__all_modules__">All Modules</MenuItem>
                                {moduleArray && moduleArray?.map((item) => (
                                    <MenuItem key={item?._id} value={item}>
                                        {item?.trainingModuleName}({item.categoryType === "Theory" ? "सैद्धांतिक" : item.categoryType === "Practical" ? "प्रात्यक्षिक" : item.categoryType})
                                    </MenuItem>
                                ))}
                            </Select>
                            {SelectModuleError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Module</span> : null}
                        </FormControl>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <Button
                            variant='contained'
                            disabled={updateLoader}
                            onClick={() => { AssignTrainerData() }}
                        >
                            {updateLoader
                                ? <CircularProgress size={20} color="inherit" />
                                : (isEditMode ? 'Update' : 'Assign Trainer')}
                        </Button>
                    </div>
                </Paper>
            </Modal>

            {/* ── Delete Confirmation Modal ─────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={deleteConfirmOpen}
                onClose={(e) => { e.preventDefault(); setDeleteConfirmOpen(false); setDeleteTarget(null) }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>
                                Are you sure you want to delete all assignments for this trainer?
                            </Typography>
                            {deleteTarget && (
                                <Typography variant='body2' color="textSecondary">
                                    {deleteTarget?.firstName} {deleteTarget?.lastName} ({deleteTarget?.contactNo})
                                </Typography>
                            )}
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setDeleteConfirmOpen(false); setDeleteTarget(null) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                        <Button variant='outlined' onClick={() => { setDeleteConfirmOpen(false); setDeleteTarget(null) }}>Cancel</Button>
                        <Button
                            variant='contained'
                            color='error'
                            disabled={deleteLoader}
                            onClick={handleDelete}
                        >
                            {deleteLoader ? <CircularProgress size={18} color="inherit" /> : 'Delete'}
                        </Button>
                    </Stack>
                </Paper>
            </Modal>

            {/* ── Module already assigned modal ─────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={moduleError}
                onClose={(e) => { e.preventDefault(); setModuleError(false); }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Trainer already assign to this Timing and date</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setModuleError(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <center>
                        <Button variant='contained' onClick={() => setModuleError(false)}>Ok</Button>
                    </center>
                </Paper>
            </Modal>

            {/* ── Already assigned modal ───────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={AlreadyAssign}
                onClose={(e) => { e.preventDefault(); setAlreadyAssign(false); }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Trainer already Assign to this Module.</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setAlreadyAssign(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <center>
                        <Button variant='contained' onClick={() => {
                            setAlreadyAssign(false);
                            navigate("/admin/assigned-trainer-list");
                            setActiveList("/admin/assigned-trainer-list")
                        }}>Ok</Button>
                    </center>
                </Paper>
            </Modal>

            {/* ── Assignment full modal ─────────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={assignmentFull}
                onClose={(e) => { e.preventDefault(); setAssignmentFull(false); }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Maximum Trainer assignment reached for this module on selected grampanchayat.</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setAssignmentFull(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <center>
                        <Button variant='contained' onClick={() => {
                            setAssignmentFull(false);
                            navigate("/admin/assigned-trainer-list");
                            setActiveList("/admin/assigned-trainer-list")
                        }}>Ok</Button>
                    </center>
                </Paper>
            </Modal>

            {/* ── Bulk Upload modal ─────────────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={openBulk}
                onClose={(e) => { e.preventDefault(); setOpenBulk(false) }}
            >
                <Paper className={classes.profilemodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Training Bulk Upload</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setOpenBulk(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: 10 }}>
                            <FormControl sx={{ m: 1, marginRight: 3 }}>
                                <InputLabel id="bulk-district-label">District</InputLabel>
                                <Select
                                    style={{ width: 250 }}
                                    id="bulk-district-label"
                                    label="District"
                                    value={bulkDistrict}
                                    onChange={(e) => { setBulkDistrict(e.target.value); }}
                                    disabled={cityArray === undefined || cityArray.length === 0}
                                    MenuProps={{ style: { maxHeight: 400 } }}
                                >
                                    {cityArray && cityArray?.map((item) => (
                                        <MenuItem key={item?._id} value={item}>
                                            {item?.districtName}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {bulkDistrictError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select City</span> : null}
                            </FormControl>
                            <FormControl sx={{ m: 1, marginRight: 3 }}>
                                <InputLabel id="bulk-module-label">Module</InputLabel>
                                <Select
                                    style={{ width: 250 }}
                                    id="bulk-module-label"
                                    label="Module"
                                    value={bulkModule}
                                    disabled={moduleArray === undefined || moduleArray.length === 0}
                                    onChange={(e) => { setBulkModule(e.target.value) }}
                                    MenuProps={{ style: { maxHeight: 400 } }}
                                >
                                    {moduleArray && moduleArray?.map((item) => (
                                        <MenuItem key={item?._id} value={item}>
                                            {item?.trainingModuleName}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {bulkModuleError ? <span style={{ color: 'red', fontSize: 15 }}>*Please Select Module</span> : null}
                            </FormControl>
                        </div>
                        <center>
                            <Button variant='contained' onClick={() => getExcel()}>Get Excel Format</Button>
                        </center>
                        <div style={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <input className={classes.input} type="file" id="myInput" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" variant="outlined" onChange={(e) => { handleChangeExcel(e) }} style={{ display: "none" }} />
                            <label htmlFor='myInput'>
                                {imgloader ? <CircularProgress color='primary' />
                                    : <IconButton color='primary' aria-label="upload picture" component="span" style={{ borderRadius: '7%', color: 'white', backgroundColor: '#1d5a96', fontSize: 17, fontWeight: 400 }} sx={{
                                        "&:hover": {
                                            backgroundColor: "#f6cc63 !important",
                                            fontSize: 17,
                                        },
                                    }} >
                                        Upload Excel
                                    </IconButton>}
                            </label>
                        </div>
                    </div>
                </Paper>
            </Modal>

            {/* ── Error modal ──────────────────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={showErr}
                onClose={(e) => { e.preventDefault(); setShowErr(false) }}
            >
                <Paper className={classes.errormodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Found Invalid Content in Excel.Please Correct it and reupload it.</Typography>
                            <Typography style={{ color: 'grey' }}>*Please check out downloaded file for error reference.</Typography>
                        </Stack>
                        <IconButton aria-label="delete" style={{ bottom: 30 }} onClick={e => { e.preventDefault(); setShowErr(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Paper>
            </Modal>

            {/* ── Success modal ────────────────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={showSuccess}
                onClose={(e) => { e.preventDefault(); setShowSuccess(false) }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>Bulk Upload Completed Successfully.</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setShowSuccess(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <center>
                        <Button variant='contained' onClick={() => {
                            navigate("/admin/assigned-trainer-list")
                            setActiveList("/admin/assigned-trainer-list")
                        }} >View</Button>
                    </center>
                </Paper>
            </Modal>

            {/* ── No GramPanchayat modal ───────────────────────────── */}
            <Modal
                className={classes.middlePosition}
                open={noGram}
                onClose={(e) => { e.preventDefault(); setNoGram(false) }}
            >
                <Paper className={classes.passmodal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                        <Stack direction="column">
                            <Typography variant='h6' component='div'>No taluka or GramPanchayat found for Selected District.</Typography>
                        </Stack>
                        <IconButton aria-label="delete" onClick={e => { e.preventDefault(); setNoGram(false) }}>
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <center>
                        <Button variant='contained' onClick={() => { setNoGram(false) }} >OK</Button>
                    </center>
                </Paper>
            </Modal>

            {/* ✅ TOAST — Snackbar */}
            <Snackbar
                open={toast.open}
                autoHideDuration={4000}
                onClose={handleToastClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleToastClose}
                    severity={toast.severity}
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {toast.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: 'column',
        marginTop: 30
    },
    card: { width: '1200px', borderRadius: '20px !important', margin: '20px', padding: '20px' },
    errormodal: { width: '600px', background: 'white', borderRadius: '20px !important', margin: '20px', padding: '20px' },
    passmodal: { width: '400px', background: 'white', borderRadius: '20px !important', margin: '20px', padding: '20px' },
    profilemodal: { width: '900px', background: 'white', borderRadius: '20px !important', margin: '20px', padding: '20px' },
    middlePosition: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
    input: { width: '100%', background: 'white', marginTop: '20px', padding: '5px 15px' },
}));

const mapStateToProps = (state) => {
    return { userDetails: state.auth.userDetails }
}

const mapDispatchToProps = dispatch => {
    return {
        setActiveList: (data) => dispatch(Action.setActiveList(data)),
        getAllTrainers: () => dispatch(Action.getAllTrainers()),
        getAllTrainingModuleData: () => dispatch(Action.getAllTrainingModuleData()),
        getAllDistrictData: () => dispatch(Action.getAllDistrictData()),
        getDistrictWiseTalukaData: (data) => dispatch(Action.getDistrictWiseTalukaData(data)),
        getTalukaWisePanchayat: (data) => dispatch(Action.getTalukaWisePanchayat(data)),
        AssignTrainertoPanchayat: (data) => dispatch(Action.AssignTrainertoPanchayat(data)),
        getSingleTrainerData: (data) => dispatch(Action.getSingleTrainerData(data)),
        DistrictWisePanchayat: (data) => dispatch(Action.DistrictWisePanchayat(data)),
        BulkTrainingInsert: (data) => dispatch(Action.BulkTrainingInsert(data)),
        getTrainingByTrainer: (data) => dispatch(Action.getTrainingByTrainer(data)),
        updateTrainingAssignTrainerBulk: (data) => dispatch(Action.updateTrainingAssignTrainerBulk(data)),
        deleteTrainingByTrainer: (data) => dispatch(Action.deleteTrainingByTrainer(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignTrainer)